import { Component, OnInit, ViewChild, ErrorHandler } from '@angular/core';

import { Http, Response } from '@angular/http';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError, config } from 'rxjs';

import { Router, Route, ActivatedRoute } from '@angular/router';

import { UserService } from '../services/user.service';
import { User } from 'models/user.model';
import { error } from 'protractor';

import { TranslateService } from '@ngx-translate/core';

import { ToastContainerDirective, ToastrService, ToastContainerModule } from 'ngx-toastr';

@Component({
  selector: 'app-checkmail',
  templateUrl: './checkmail.component.html',
  styleUrls: ['./checkmail.component.css']
})
export class CheckmailComponent implements OnInit {

  constructor(
    private router: Router,
    private userService: UserService,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private toastr: ToastrService
  )

  { }

  ngOnInit() {

    this.translate.use(localStorage.getItem('localLanguage'));

    const username = this.route.snapshot.paramMap.get('username');
    const random = this.route.snapshot.paramMap.get('random');
    const IsWebUser = true;

    this.userService.checkmail(username, random, IsWebUser)
      .subscribe(
      data => {
        this.router.navigate(['/']);
        this.translate.get('EMAIL_200.TITLE').subscribe((res: string) => {
          this.toastr.success(res, null, {
            positionClass: 'toast-top-center',
            timeOut: 2000
          })
        });
      },
      error => {
        if (error.status == 500) {
          this.router.navigate(['/errorPage'])
        }
      });
  }

}
